import store from '@/store/index.js'

export default {
  /** 編集、キャンセルが可能か */
  getIsUpdatable: async (id) => {
    return store
      .dispatch('order/getIsUpdatable', {
        jyuchuSyaryoId: id,
      })
      .then((res) => res.data.isUpdatable)
      .catch((error) => console.log(error))
  },
}



// WEBPACK FOOTER //
// ./src/api/order.js